// One What's next line with the order's tracking numbers as links
// (2026-10-29, docs/decisions/2026-10-29-items-widget-fast-rows-caches.md).
// links: the suggestion's modelMeta.nextStepTrackingLinks. A number the line
// names is a link in the text; a line that asks to check a package but names
// no number gets "Tracking: <number> (<carrier>)" under it, one link per
// number, the parent order's first (@cxhub/shared's nextStepTrackingView()).
// Every link opens in a new window, like the header's tracking links. A line
// about something else, or an order with no tracking, shows as it is.
import { Box, Link } from '@mui/material'
import { nextStepTrackingView, nextStepTrackingLabel } from '@cxhub/shared'

function TrackingLink({ link, children }) {
  if (!link?.url) return <>{children}</>
  return (
    <Link href={link.url} target="_blank" rel="noopener noreferrer" data-testid="next-step-tracking-link">{children}</Link>
  )
}

export function NextStepText({ text, links = null }) {
  const view = nextStepTrackingView(text, links)
  return (
    <>
      {view.segments.map((seg, i) => (seg.link
        ? <TrackingLink key={i} link={seg.link}>{seg.text}</TrackingLink>
        : <Box component="span" key={i}>{seg.text}</Box>))}
      {view.linkLine && (
        <Box data-testid="next-step-tracking-line" sx={{ fontSize: '0.92em' }}>
          {'Tracking: '}
          {view.linkLine.map((link, i) => (
            <Box component="span" key={link.number}>
              {i > 0 ? ', ' : ''}
              <TrackingLink link={link}>{nextStepTrackingLabel(link)}</TrackingLink>
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}
